import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { HeaderRowStyled, HeaderRowTitle } from './HeaderRow.styles';

export const HeaderRow = ({
  icon,
  title,
  size = '24px',
}: {
  icon: string;
  title: string;
  size?: string;
}) => {
  return (
    <HeaderRowStyled>
      <StyledIcon className={`uil uil-${icon}`} size={size} />
      <HeaderRowTitle>{title}</HeaderRowTitle>
    </HeaderRowStyled>
  );
};
